module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3b9If"))).then(() => parcelRequire('d0iPb'));